module.exports = __webpack_public_path__ + "static/media/blue-check-icon.0fcb5bbf.svg";